import React, {useState, useContext, useEffect} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Pressable, ScrollView, Text, View } from 'react-native';
import { CONVERSATIONS_WITH_COUNT, UPDATE_CONVERSATION } from './queries';
// import SubNav from './SubNav';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import AuthContext from '../../contexts/AuthContext';
import MessageInputContext from '../../contexts/MessageInputContext';
import { useQuery, useMutation } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faMessage, faCircleXmark } from '@fortawesome/free-solid-svg-icons';

import { MainContainer, ContentContainer } from '../../elements';
import { elGreen, elRed } from '../../styles/colors';

const inputStyle = {
  marginBottom: '10px'
}

const Conversations = ({indexRefetch, pendingResponses}) => {
  const {
    conversations,
    setCurrentConversationId,
    setShowModal,
    orderAndSetConversations,
    addToOpens,
    removeFromCollapsed,
    removeFromOpens
  } = useContext(MessageInputContext);
  const { user } = useContext(AuthContext);
  // const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [clickedConversation, setClickedConversation] = useState();
  const queryVariables = {
    scopes: ['is_open'],
  };

  const { data, refetch } = useQuery( CONVERSATIONS_WITH_COUNT, {
    variables: { scopes: ['is_open'] }
  });

  useEffect(() => {
    if(data) {
      orderAndSetConversations(data?.conversationsWithCount.entries);
    }
  }, [data])

  useEffect(() => {
    if(pendingResponses) {
      refetch();
    }
  }, [pendingResponses])

  const [updateConversation] = useMutation(UPDATE_CONVERSATION, {
    onCompleted: (response) => {
      setCurrentConversationId(
        response.updateConversation.conversation.id
      )
      if(refetch) {
        refetch();
      }
      if(indexRefetch) {
        indexRefetch();
      }
    }
  });

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    // {
    //   key: 'id',
    //   label: 'ID'
    // },
    {
      key: 'fromPaddleService',
      label: 'Paddle Service',
      sort: 'ASC',
      content: (entry) => {
        return entry.entry.lastIncoming?.fromPaddleService ? 'Yes' : 'No'
      }
    },
    {
      key: 'assignedTo',
      label: 'Assigned to Name',
      // width: '20%',
      content: (entry) => {
        return entry.entry.assignedTo?.fullName
      }
    },
    {
      key: 'buyer',
      label: 'Buyer',
      content: (entry) => {
        return entry.entry.lastIncoming?.buyerUser ?
          `${entry.entry.lastIncoming?.buyerUser?.buyer?.name}
            (User: ${entry.entry.lastIncoming?.buyerUser?.fullName})` :
          null
      }
    },
    {
      key: 'lastMessage',
      label: 'Last Message',
      content: (entry) => {
        return (
          <div style={{display: 'flex', flexDirection: 'row'}}>
            {entry.entry.lastIncoming?.body}
            {entry.entry.isPendingResponse &&
              <>
                <Pressable
                  onPress={() => handleClick(
                    entry.entry.id,
                    entry.entry.assignedTo?.id
                  )}
                >
                  <FontAwesomeIcon
                    icon={faMessage}
                    size={'1x'}
                    color={elRed}
                    style={{marginLeft: '10px'}}
                  />
                </Pressable>
              </>
            }
          </div>
        )
      }
    },
    {
      key: 'isPendingResponse',
      label: 'Responded',
      content: (entry) => entry.entry.isPendingResponse ? 'Needs Response' : 'Responded'
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => {
        return (
          <div style={{display: 'inline-flex', gap: '10px'}}>
            <Pressable
              onPress={() => handleClick(
                entry.entry.id, entry.entry.assignedTo?.id, false
              )}
            >
              <FontAwesomeIcon
                icon={faReply}
                size={'1x'}
                color={entry.entry.isPendingResponse ? elRed : elGreen}
              />
            </Pressable>
            <Pressable
              onPress={() => handleClick(
                entry.entry.id, entry.entry.assignedTo?.id, true
              )}
            >
              <FontAwesomeIcon
                icon={faCircleXmark}
                size={'1x'}
                color={elRed}
              />
            </Pressable>
          </div>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>
          {/* <Text>Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.street || ''}
            style={inputStyle}
          /> */}
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );
  const handleClick = (conversationId, assignedId, close) => {
    let variables = {
      variables: {
        id: conversationId,
        assigned: assignedId ? assignedId : user.id,
        status: close ? 'Closed' : 'Open'
      }
    }

    // if(!assigned) {
      updateConversation(variables)
    // }
    // setCurrentConversationId(conversationId);
    if(close) {
      removeFromOpens(conversationId);
      removeFromCollapsed(conversationId);
    }else {
      addToOpens(conversationId);
      setShowModal(true);
    }
  }

  return (
    <MainContainer>
      {/* <SubNav refetch={refetch} /> */}
      <ScrollView style={{
        maxHeight: setShowModal ? '280px' : 'fit-content'
      }}>
        <DataTable.Simple
          data={conversations}
          columns={columns}
          pageLength="All"
          htmlTable
        />
      </ScrollView>

    </MainContainer>
  )
}

export default Conversations;
